import Inline from '../blots/inline.js';

class Underline extends Inline { }
Underline.blotName = 'underline';
Underline.tagName = 'U';

export default Underline;



// WEBPACK FOOTER //
// ./formats/underline.js